import React from "react";

import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

//
import Header from "./components/Header";
import Footer from "./components/Footer";
//
import Welcome from "./pages/Welcome/Welcome";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import AboutPage from "./pages/About/AboutPage";
import WorkPage from "./pages/HowWeWork/WorkPage";
// Services
import AppDevelopment from "./pages/Services/AppDevelopment";
import SaasService from "./pages/Services/SaasService";
import BusinessIntelligence from "./pages/Services/BusinessIntelligence";

function App() {
  const [open, setOpen] = React.useState("");
  // asd;
  const services = [
    { path: "app-development", component: AppDevelopment },
    { path: "saas-service", component: SaasService },
    { path: "business-intelligence", component: BusinessIntelligence },
  ];

  const asd = "asdf1234";
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          {services.map(({ path, component: Component }) => {
            return (
              <Route
                key={path}
                path={`/services/${path}`}
                element={<Component />}
              />
            );
          })}
          <Route path="/how-we-work" element={<WorkPage />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
